import SammioHelp from './components/SammioHelp'
import SammioStatutes from './components/statutes/SammioStatutes'
import SammioSearch from './components/search/SammioSearch'
import SammioBookmarks from "./components/SammioBookmarks"
import Sammio404 from "./components/Sammio404"
import SammioFrequentSearches from "./components/SammioFrequentSearches";
import SammioNews from "@/components/SammioNews";

export const routes = [
    { name: 'search', path: '/', component: SammioSearch },
    { name: 'search_redirect', path: '/etusivu', redirect: '/' },
    { name: 'help', path: '/ohje', component: SammioHelp, props: { articleType: "help" } },
    { name: 'accessibility', path: '/saavutettavuusseloste', component: SammioHelp, props: { articleType: "accessibility" } },
    { name: 'statutes_root', path: '/saadokset', component: SammioStatutes, props: { urlStatuteIndex: "1", doScroll: false} },
    { name: 'statutes', path: '/saadokset/:urlStatuteIndex/:urlChapterIndex/:urlSectionIndex', component: SammioStatutes, props: true },
    { name: 'statutes_card', path: '/saadokset/:urlStatuteIndex/:urlChapterIndex/:urlSectionIndex/:urlSubsectionIndex', component: SammioStatutes, props: true },
    { name: 'bookmarks', path: '/muistilista', component: SammioBookmarks },
    { name: 'bookmarks_get', path: '/muistilista/:shortUrl', component: SammioBookmarks, props: true },
    { name: 'frequentsearches', path: '/valmishaut', component: SammioFrequentSearches },
    { name: 'search_card', path: '/:urlStatuteIndex/:urlChapterIndex/:urlSectionIndex/:urlSubsectionIndex', component: SammioSearch, props: true },
    { name: 'announcement', path:'/ajankohtaista', component: SammioNews, props: { articleType: "announcement"} },
    { name: '404', path: '*', component: Sammio404 }
];
